module.exports = __webpack_public_path__ + "static/media/arrow-down-black.39788c2e.svg";